import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { routeList } from "./navigation/routes";
import { NotificationContext } from "./components/Notification/types";
import { ResizeObserverProvider } from "./hooks/useResizeObserver";
import { ScreenProvider } from "./hooks/useScreen";
import { notification } from "antd";
import { setNotificationAPI } from "./components/Notification";
import { AuthProvider } from "./hooks/useAuth";
const App = () => {
  const contextValue = useMemo(() => ({ name: "Ant Design" }), []);
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    setNotificationAPI(api);
  }, [api]);

  return (
    <NotificationContext.Provider value={contextValue}>
      <BrowserRouter>
        <AuthProvider>
          <ResizeObserverProvider>
            <ScreenProvider>
              {contextHolder}
              <Routes>
                {routeList.map((i) => (
                  <Route key={i.path} path={i.path} element={i.element} />
                ))}
              </Routes>
            </ScreenProvider>
          </ResizeObserverProvider>
        </AuthProvider>
      </BrowserRouter>
    </NotificationContext.Provider>
  );
};

export default App;
